<template>
	<div>
		<div class="text-center">
			<loading :active.sync="isFetching" :is-full-page="fullPage" :background-color="colorOverlay" :color="colorLoading">
				<template slot="after">
					<div class="absolute mt-1 ml-1 text-center">Loading...</div>
				</template>
			</loading>
		</div>
		<div class="page page-hidden-package" v-if="!this.isFetching">
			<div class="view-plans container-hidden-subs" v-if="!isShowPayment && item && item.is_published && !isNotLoggedIn">
				<img :src="item.file_path" alt="Grafias" class="image-hidden-package" v-if="item.file_path">
				<h1 class="text-center mt-4">{{item.name}}</h1>
				<div class="bg-grey-tb mt-2 mb-3 bg-hidden-subs-table">
					<table class="table table-striped mb-4">
						<thead>
							<tr>
								<th class="bg-main-tb">{{ $t('Features') }}</th>
								<th class="text-center bg-main-tb">
									<div>Limit</div>
								</th>
							</tr>
						</thead>
						<tbody>
							<td class="p-0">
								<div class="pl-4 feature-name" v-for="(item, index) in featureNames"
									:key="'FeatureName_'+index"
									:class="{'bg-grey-tb': index % 2, 'bg-main-tb':index % 2}">
									{{item.feature_name}}
								</div>
								<div class="pl-4 price-per-month mb-5">{{ $t('Price') }}</div>
							</td>
							<td
								class="text-center p-0 relative">
								<div class="align-middle feature-name"
									:class="{'bg-grey-tb': index % 2,'bg-main-tb':index % 2}"
									v-for="(feature, index) in item.packageFeatures"
									:key="'feature_'+index">
									<!-- condition normalize data storage -->
									<span v-if="index !== 4 && item.type !== 'non_feature' && feature.feature_id !== 6 && feature.feature_id !== 7">{{ feature.limit === 0 ? 'UNLIMITED' : feature.limit  }}</span>
									<span v-if="index === 4 && item.type !== 'non_feature' && feature.feature_id !== 6 && feature.feature_id !== 7">{{ convertDataSize(feature.limit === 0 ? 'UNLIMITED' : feature.limit)  }}</span>
									<!-- render sequence -->
									<span v-if="feature.feature_id === 6 && feature.is_enabled">Available</span>
									<span v-if="feature.feature_id === 6 && !feature.is_enabled">-</span>
									<!-- limit api -->
									<span v-if="feature.feature_id === 7">{{ feature.limit === 0 ? 'UNLIMITED' : feature.limit  }}</span>
								</div>
								<h5 class="align-middle price-subs price-info-subs">
									<span v-if="item.price !== 0">${{ commaFormatted(item.price) }}<span v-if="!getPeriod(item).includes('days') && !getPeriod(item).includes('months')"> / </span><span class="text-primary"> {{getPeriod(item)}}</span></span>
								</h5>
							</td>
						</tbody>
					</table>
				</div>
				<div class="mt-0 pt-0 btn-buy-hidden-package">
					<button v-if="item.name !== 'Free' && item.id !== ActiveSubscriptionId" type="button"
						class="btn btn-lg btn-primary w-100 "
						@click="showPayment(item)">{{ $t('Buy Now') }}
					</button>
					<button v-if="item.id === ActiveSubscriptionId" type="button"
						class="btn btn-lg btn-primary w-100 disabled">{{ $t('Current Plan') }}
					</button>
				</div>
				<div class="btn-buy-hidden-package">
					{{item.description}}
				</div>
			</div>

			<!-- Payment -->
			<div class="tab-content col-sm-4 payment-form container-hidden-subs" v-if="isShowPayment">
				<div>
					<form @submit.prevent="">
						<div class="mb-2">
							<h2 class="font-weight-normal">{{ $t('Payment') }}</h2>
						</div>
						<span>Subscription & payment are handled by </span><span><a href="https://stripe.com" target="_blank">Stripe</a></span>
						<div  class="form-group mt-3">
							<div class="mh-50">
								<input v-model="paymentName" type class="form-control field" placeholder="Name" :class="{'error-input': paymentName === '', 'mb-4': paymentName.length >= 5 || paymentName.length === 0}">
								<span v-if="paymentName.length < 5 && paymentName.length !== 0" class="error-color-input">Please enter a name of at least 5 characters</span>
							</div>
							<input v-model="paymentEmail" type="email" name="email" class="form-control field  mb-3" placeholder="E-mail" :class="{'error-input': paymentEmail === ''}">
							<div class="row">
								<div class="col-sm-9">
									<input v-model="promoCode" :class="{'error-input': (!promoValid && promoCode !=='')}" type="text" name="promo" class="form-control mb-3" placeholder="PROMO CODE" v-uppercase>
								</div>
								<div class="col-sm-3 ml-0 pl-0">
									<button :class="{ 'is-loading': isCheckPromoCode, 'disabled': promoCode === '' }"
									@click="checkPromoCode()" class="btn btn-default h-70 w-100 pl-0 pr-0">Apply Promo</button>
								</div>
							</div>
							<div id="card-element" class="stripe-field"></div>
							<!-- We'll put the error messages in this element -->
							<div id="card-errors" role="alert"></div>
						</div>
						<div class="d-flex justify-content-between">
							<div>
								<button :class="{ 'is-loading': isPaymentSuccess }"
								class="btn btn-primary mb-2 mr-2" @click="checkout(selectedPackage)" :disabled="(!isValidNameAndEmail && isValidCreditCard) || (!promoValid && promoCode !== '')">Pay For {{ selectedPackage && selectedPackage.name ? selectedPackage.name : 'unknown package' }}</button>
							</div>
							<div>
								<button class="btn btn-default mb-2" @click="isShowPayment = false">Cancel</button>
							</div>
						</div>
						<label :class="{'text-red': promoInformation === 'Promo code is unavailable', 'text-yellow': promoInformation === 'You cannot use this promo code for this current package'}"
						v-if="promoInformation">{{promoInformation}}</label>
					</form>
				</div>
			</div>

			<!-- Payment Success -->
			<div>
				<modal size="small-medium" class="swap-modal" @close="goToRundown" v-if="modalSuccessPayment">
					<template slot="header">
						<h5 class="mb-0">{{ $t('Payment Success') }}</h5>
					</template>
					<template slot="body">
						<div class="text-center mt-2 mb-3">
							<img src="/img/logo/grafias_medium_ondark.png" alt="xls" width="150px"/>
							<h5 class="mt-4 text-white">{{ $t(`Your subscription has been updated, your current subscription is ${packageName}`) }}</h5>
							<h5 class="text-white">{{ $t(' Thank you for your purchase') }}</h5>
						</div>
					</template>
					<template slot="footer">
						<button type="submit" class="btn btn-default" @click="goToRundown()">
							{{ $t('Go to rundown') }}
						</button>
						<button type="submit" class="btn btn-submit btn-primary"
							@click="isModalnvoiceVisible = true">
							{{ $t('Invoice') }}
						</button>
					</template>
				</modal>
			</div>

			<!-- Payment Loader -->
			<div class="full-loader" v-if="isSavingCard">
				<div class="message-box text-center">
					<div class="message-box-icon flex-center mb-4">
						<div class="white-dot"></div>
					</div>
					<h3 class="mb-4">{{ $t('Verifying Payment') }}</h3>
					<!-- <div class="text-lg mb-4">Please wait for a few seconds, we will redirect you to your dashboard</div> -->
				</div>
			</div>

			<!-- Invoice Modal -->
			<invoice-modal
				:data="dataTransactionSuccess"
				@close="isModalnvoiceVisible = false"
				v-if="isModalnvoiceVisible"
			/>
		</div>
		<div class="text-center" v-if="!this.isFetching && item && !item.is_published">
			<h4>Sorry, the package you are looking for is no longer available</h4>
			<h4 class="text-primary pointer" @click="goToRundown">Back to dashboard</h4>
		</div>
		<div>
			<div class="container-hidden-subs mt-5 pt-5 text-center" v-if="isNotLoggedIn">
				<div class="login-logo">
					<picture>
						<img src="/img/logo/grafias_medium_ondark.png" class="d-inline-block m-auto" loading="lazy" alt="Grafias">
					</picture>
				</div>
				<div class="pl-1">
					<div class="text-lg mb-1">{{ $t('Before you buy this promo you must ') }} <router-link class="text-primary" to="/login">{{ $t('Login') }}</router-link> {{ $t(' to Grafias') }}</div>
					<div class="text-lg mb-1">{{ $t('Don\'t have an account?') }} <router-link class="text-primary" to="/register">Please Register first </router-link></div>
					<div class="btn btn-submit btn-primary mt-4	 mb-5 w-340" @click="isNotLoggedIn = false">
						{{ $t('Go back') }}
					</div>
					<div class="text-lg mb-1">{{ $t('This page will redirect to Register page in') }} <span class="text-primary">{{counter}}</span> {{ $t('seconds') }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import dayjs from 'dayjs';
import Loading from 'vue-loading-overlay';
import localforage from 'localforage';
import 'vue-loading-overlay/dist/vue-loading.css';
import relativeTime from 'dayjs/plugin/relativeTime';
import { mapGetters, mapActions } from 'vuex';
import InvoiceModal from '@/components/InvoiceModal.vue';
import Modal from '@/components/Modal.vue';
import { getAxiosErrorMessage, getVideoBlob } from '@/lib/helper';
import packagesApi from '@/api/packages';
import transactionApi from '@/api/transactions';
import promoCodeApi from '@/api/promoCode';
import authApi from '@/api/auth';

const publicKeyStripe = process.env.VUE_APP_PK_STRIPE ? process.env.VUE_APP_PK_STRIPE : 'pk_test_cEeFbGOnhljGBjRCCjp7h3dL00SPobqhFE';
export default {
	name: 'HiddenPackage',
	components: {
		Modal,
		InvoiceModal,
		Loading,
	},
	data() {
		return {
			descriptionPackage: [
				{ key: 'Display-Output', label: 'Display Output' },
				{ key: 'Assets-In-Rundown', label: 'Assets In Rundown' },
				{ key: 'Rundowns', label: 'Rundowns' },
				{ key: 'Adding-Users', label: 'Adding Users (Collaborate)' },
				{ key: 'Storage', label: 'Storage' },
				{ key: 'Time-Constraint', label: 'Time Constraint' },
				{ key: 'Support', label: 'Support' },
				{ key: 'Price-per-month', label: 'Price per month' },
			],
			packages: [],
			isShowTour: false,
			lastKeywordTemplate: '',
			lastCategoryTemplate: false,
			modalSuccessPayment: false,
			lastCategoryGallery: '',
			lastKeywordGallery: '',
			isModalnvoiceVisible: false,
			dataTransactionSuccess: {},
			item: {},
			isFetching: false,
			keyword: '',
			stripeAPIToken: publicKeyStripe,
			stripe: '',
			elements: '',
			card: null,
			customer: {},
			promoCode: '',
			isShowPayment: false,
			currentItem: {},
			selectedPackage: null,
			paymentName: '',
			paymentEmail: '',
			isShowPlan: false,
			isPaymentSuccess: false,
			isCheckPromoCode: false,
			promoInformation: '',
			promoValid: false,
			// change password
			isChangePassword: false,
			isFormPasswordVisible: false,
			cancelledSubs: null,
			isValidCreditCard: true,
			isCancelSubs: false,
			// more feature
			isShowMoreFeature: false,
			isLoadingMoreFeature: false,
			packagePrice: '',
			transactionPrice: null,
			currentCoupon: null,
			packageName: '',
			// change payment
			isChangePaymentModal: false,
			isSavingPayment: false,
			// apply promo from email
			promoCodeFromEmail: '',
			isApplyingCoupon: false,
			isRemoveLocalForage: false,
			tab: '',
			isSavingCard: false,
			// loading
			fullPage: true,
			colorOverlay: '#000000',
			colorLoading: '#FFFFFF',
			// modal redirect
			isNotLoggedIn: false,
			counter: 15,
			redirect: '/register',
			// cache image
			mediaSource: '',
		};
	},
	sockets: {},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		...mapGetters({
			user: 'user',
		}),
		userId() {
			return this.user && this.user.id ? this.user.id : null;
		},
		featureNames() {
			const featureNames = this.item ? this.item.packageFeatures : [];
			return featureNames;
		},
		userSubscriptions() {
			const userSubs = this.user && this.user.userSubscriptions ? this.user.userSubscriptions : '';
			return userSubs;
		},
		ActiveSubscriptionId() {
			return this.ActiveSubscription && this.ActiveSubscription.package_id ? this.ActiveSubscription.package_id : null;
		},
		ActiveSubscription() {
			const subscriptions = this.userSubscriptions;
			if (subscriptions) {
				// eslint-disable-next-line camelcase
				const activeSubs = subscriptions.find(({ is_current_active }) => is_current_active);
				return activeSubs;
			}
			return null;
		},
		userSettings() {
			return this.user && this.user.settings ? this.user.settings : null;
		},
		isValidNameAndEmail() {
			return this.paymentEmail !== '' && this.paymentName !== '' && this.paymentName.length >= 5;
		},
		uid() {
			const id = this.$route.params.uid;
			return id;
		},
	},
	methods: {
		...mapActions({
			setUser: 'setUser',
		}),
		goToRundown() {
			this.$router.push('/').catch(() => {});
		},
		convertDataSize(size) {
			if (size === 'UNLIMITED') return 'UNLIMITED';
			if (size < 1000) {
				return `${size}MB`;
			}
			return `${size / 1000}GB`;
		},
		checkPromoCode() {
			this.isCheckPromoCode = true;
			const callback = (response) => {
				const promo = response.data;
				this.currentCoupon = promo.coupon;
				const activePackage = response.data.packages;
				const messageDiscountPrice = promo.coupon.amount_off ? promo.coupon.amount_off : '';
				const messageDiscountPercentage = promo.coupon.percent_off ? promo.coupon.percent_off : '';
				let totalDiscount = '';
				if (messageDiscountPrice) {
					totalDiscount = `: $${messageDiscountPrice / 100}`;
				} else if (messageDiscountPercentage) {
					totalDiscount = `: ${messageDiscountPercentage}%`;
				}
				// eslint-disable-next-line eqeqeq
				const isAllPackage = activePackage.length == 0;
				if (!isAllPackage) {
					const currentPackageId = this.selectedPackage && this.selectedPackage.id ? this.selectedPackage.id : null;
					if (currentPackageId) {
						const validPackage = activePackage.findIndex(({ id }) => id === currentPackageId);
						if (validPackage === -1) {
							// this.$notify({
							// 	group: 'app',
							// 	type: 'error',
							// 	title: 'Error, You cannot use promo code for this package',
							// 	text: 'You cannot use this promo code for this current package',
							// });
							this.promoInformation = 'You cannot use this promo code for this current package';
							this.promoValid = false;
							this.isCheckPromoCode = false;
						} else {
							// this.$notify({
							// 	group: 'app',
							// 	type: 'success',
							// 	title: 'success, promo code Available',
							// 	text: `your promo code is activated${totalDiscount} OFF`,
							// });
							this.promoInformation = `Your promo code is activated${totalDiscount} OFF`;
							this.promoValid = promo.code;
							this.isCheckPromoCode = false;
						}
					} else {
						// this.$notify({
						// 	group: 'app',
						// 	type: 'error',
						// 	title: 'Error, You have not select any package',
						// 	text: 'You have not select any package',
						// });
						this.promoInformation = 'You have not select any package';
						this.promoValid = false;
						this.isCheckPromoCode = false;
					}
				} else {
					// this.$notify({
					// 	group: 'app',
					// 	type: 'success',
					// 	title: 'success, promo code Available',
					// 	text: `your promo code is activated${totalDiscount} OFF`,
					// });
					this.promoInformation = `Your promo code is activated${totalDiscount} OFF`;
					this.promoValid = promo.code;
					this.isCheckPromoCode = false;
				}
			};
			const errCallback = () => {
				// this.$notify({
				// 	group: 'app',
				// 	type: 'error',
				// 	title: 'Failed, promo code is unavailable',
				// 	text: message,
				// });
				this.promoInformation = 'Promo code is unavailable';
				this.promoValid = false;
				this.isCheckPromoCode = false;
			};
			promoCodeApi.getByCode(this.promoCode, callback, errCallback);
		},
		showPayment(item) {
			if (this.user) {
				this.isNotLoggedIn = false;
				this.paymentName = this.user && this.user.name ? this.user.name : '';
				this.paymentEmail = this.user && this.user.email ? this.user.email : '';
				this.selectedPackage = item;
				this.isShowPayment = true;
				this.$nextTick(() => {
					this.configureStripe();
				});
			} else {
				this.counter = 15;
				this.isNotLoggedIn = true;
				this.countDown();
			}
		},
		checkout(pkg) {
			this.packagePrice = this.commaFormatted(pkg.price);
			if (this.promoValid && this.currentCoupon) {
				if (this.currentCoupon.amount_off) this.packagePrice = this.commaFormatted(parseInt(pkg.price) - (parseInt(this.currentCoupon.amount_off) / 100));// initially amount of is 10.00 so would be 1000 in json int
				if (this.currentCoupon.percent_off) this.packagePrice = this.commaFormatted(parseInt(pkg.price) - (parseInt(pkg.price) * (parseInt(this.currentCoupon.percent_off) / 100))); // no need to parse comma
				if (this.packagePrice <= 0) this.packagePrice = 0;
			}
			this.packageName = pkg.name;
			this.isPaymentSuccess = true;
			const param = {
				package_id: pkg.id,
				bill_to_name: this.paymentName,
				bill_to_email: this.paymentEmail,
			};
			if (this.promoValid) {
				param.promo_code = this.promoCode.toUpperCase();
			}
			const callback = (response) => {
				if (response && response.error) {
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Failed, Payment Declined',
						text: 'Failed, Payment Declined',
					});
				}
				this.customer = response.data;
				const card = this.card;
				this.createPaymentMethod({ card });
				// this.isPaymentSuccess = false;
			};
			const errCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Failed, Payment Declined',
					text: message,
				});
				this.isPaymentSuccess = false;
			};
			transactionApi.checkout(param, callback, errCallback);
		},
		handlePaymentThatRequiresCustomerAction(subscription, priceId, paymentMethodId) {
			if (subscription && subscription.status === 'active') {
				// subscription is active, no customer actions required.
				const callback = (response) => {
					const subsData = response.data;
					const transaction = subsData.transaction;
					this.transactionPrice = transaction.amount;
					const subsUser = subsData.user;
					this.dataTransactionSuccess = response.data.transaction;
					this.isPaymentSuccess = false;
					this.setUser(subsUser);
					this.$notify({
						group: 'app',
						type: 'success',
						title: 'success, Payment Accepted',
						text: `Your subscription has been updated, your current subscription is ${this.packageName}`,
					});
					// this.$router.push('/').catch(() => {});
					this.getProfileUser();
					this.modalSuccessPayment = true;
				};
				const errCallback = (e) => {
					const message = getAxiosErrorMessage(e);
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Failed, Payment Declined',
						text: message,
					});
					this.isPaymentSuccess = false;
				};
				const invoiceId = subscription && typeof (subscription.latest_invoice) === 'string' ? subscription.latest_invoice : subscription.latest_invoice.id;
				const params = {
					subscription_id: subscription.id,
					invoice_id: invoiceId,
				};
				transactionApi.successed(params, callback, errCallback);
				return { subscription, priceId, paymentMethodId };
			}

			// If it's a first payment attempt, the payment intent is on the subscription latest invoice.
			// If it's a retry, the payment intent will be on the invoice itself.
			const latestInvoice = subscription && subscription.latest_invoice ? subscription.latest_invoice : null;
			const paymentIntent = latestInvoice && latestInvoice.payment_intent ? latestInvoice.payment_intent : null;
			if (
				paymentIntent.status === 'requires_action'
				|| (paymentIntent.status === 'requires_payment_method')
			) {
				return this.stripe
					.confirmCardPayment(paymentIntent.client_secret, {
						payment_method: paymentMethodId,
					})
					// eslint-disable-next-line consistent-return
					.then((result) => {
						if (result.error) {
							// start code flow to handle updating the payment details
							// Display error message in your UI.
							// The card was declined (i.e. insufficient funds, card has expired, etc)
							// throw result;\
							const message = result.error.message;
							this.$notify({
								group: 'app',
								type: 'error',
								title: 'Failed, Payment Declined',
								text: message,
							});
							this.isPaymentSuccess = false;
						} else if (result.paymentIntent.status === 'succeeded') {
							// There's a risk of the customer closing the window before callback
							// execution. To handle this case, set up a webhook endpoint and
							// listen to invoice.paid. This webhook endpoint returns an Invoice.
							const callback = (response) => {
								const subsData = response.data;
								const transaction = subsData.transaction;
								this.transactionPrice = transaction.amount;
								const subsUser = subsData.user;
								this.dataTransactionSuccess = response.data.transaction;
								this.setUser(subsUser);
								this.isPaymentSuccess = false;
								this.$notify({
									group: 'app',
									type: 'success',
									title: 'success, Payment Accepted',
									text: `Your subscription has been updated, your current subscription is $${this.packageName}`,
								});
								// this.$router.push('/').catch(() => {});
								this.getProfileUser();
								this.modalSuccessPayment = true;
							};
							const errCallback = (e) => {
								const message = getAxiosErrorMessage(e);
								this.$notify({
									group: 'app',
									type: 'error',
									title: 'Failed, Payment Declined',
									text: message,
								});
								this.isPaymentSuccess = false;
							};
							const params = {
								subscription_id: subscription.id,
								invoice_id: latestInvoice.id,
							};
							transactionApi.successed(params, callback, errCallback);
						}
					});
			}
			// No customer action needed
			return { subscription, priceId, paymentMethodId };
		},
		// eslint-disable-next-line no-unused-vars
		createPaymentMethod({ card, isPaymentRetry, invoiceId }) {
			// eslint-disable-next-line no-undef
			this.stripe
				.createPaymentMethod({
					type: 'card',
					card,
					billing_details: {
						name: this.paymentName,
						email: this.paymentEmail,
					},
				})
				.then((result) => {
					// const transactionId = result.transaction_id;
					if (result.error) {
						this.isPaymentSuccess = false;
						const error = result.error;
						const message = error.message;
						this.$notify({
							group: 'app',
							type: 'error',
							title: 'Failed, Payment Declined',
							text: message,
						});
					}
					return result;
				}).then((result) => {
					const paymentMethod = result && result.paymentMethod ? result.paymentMethod.id : '';
					if (paymentMethod) {
						this.createSubscription(paymentMethod);
					}
				});
		},
		createSubscription(paymentMethodId) {
			this.isPaymentSuccess = true;
			const trxId = this.customer.transaction.id;
			const params = {
				status: 'paid',
				transaction_id: trxId,
				payment_method_id: paymentMethodId,

			};
			const callback = (response) => {
				const subscription = response.data.subscription;
				const priceId = response.price_id;
				this.handlePaymentThatRequiresCustomerAction(subscription, priceId, paymentMethodId);
			};
			const errCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Failed, Payment Declined',
					text: message,
				});
				this.isPaymentSuccess = false;
			};
			transactionApi.process(params, callback, errCallback);
		},
		configureStripe() {
			// eslint-disable-next-line no-undef
			this.stripe = Stripe(this.stripeAPIToken, { locale: 'en' });
			this.elements = this.stripe.elements();
			this.card = this.elements.create('card', {
				style: {
					base: {
						iconColor: '#6051ff',
						color: 'white',
						lineHeight: '48px',
						fontWeight: 400,
						fontFamily: '"Open Sans", "Helvetica Neue", "Helvetica", sans-serif',
						fontSize: '15px',
						'::placeholder': {
							color: '#CFD7DF',
						},
					},
				},
			});
			this.card.mount('#card-element');

			this.card.on('change', (event) => {
				const displayError = document.getElementById('card-errors');
				if (event.error) {
					displayError.textContent = event.error.message;
					this.isValidCreditCard = false;
				} else if (event.empty) {
					displayError.textContent = '';
					this.isValidCreditCard = false;
				} else {
					displayError.textContent = '';
					this.isValidCreditCard = true;
				}
			});
		},
		sortFeature(features) {
			// eslint-disable-next-line
			features.sort((a, b) => {
				return a.feature_id - b.feature_id;
			});
			return features;
		},
		fetch() {
			this.isFetching = true;
			const callback = (response) => {
				const item = response.data;
				this.item = item;
				const element = this.item;
				// push temporary data for showing render feature
				if (element.packageFeatures.length === 6) {
					element.packageFeatures.push({
						feature_id: 6,
						feature_name: 'Render Sequence',
						is_enabled: false,
					});
				}
				// sort by id
				this.sortFeature(element.packageFeatures);
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Packages',
					text: message,
				});
				this.isFetching = false;
			};
			packagesApi.get(this.uid, callback, errorCallback);
		},
		// make it a humanly readable date
		getPeriod(item) {
			const length = item.length;
			const type = item.length_type;
			const resultDate = dayjs().to(dayjs().add(length, type));
			const parsedDate = this.replaceDate(resultDate, item);
			return parsedDate;
		},
		replaceDate(str) {
			let finalResultDate = str;
			const newStr = str.replace('in a ', '');
			const ina = newStr.replace('in ', '');
			finalResultDate = ina;
			if (finalResultDate.includes('days')) {
				finalResultDate = `for ${finalResultDate}`;
			} else if (finalResultDate.includes('months')) {
				finalResultDate = `for ${finalResultDate}`;
			} else {
				finalResultDate = `${finalResultDate}`;
			}
			return finalResultDate;
		},
		commaFormatted(value) {
			if (this.item) {
				return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			}
			return '';
		},
		getProfileUser() {
			const callback = (response) => {
				const user = response.data;
				this.setUser(user);
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Profile',
					text: message,
				});
			};
			authApi.getProfile(callback, errorCallback);
		},
		countDown() {
			if (this.counter > 0) {
				setTimeout(() => {
					this.counter -= 1;
					this.countDown();
				}, 1000);
			} else {
				this.$router.push('/register').catch(() => {});
			}
		},
		promoUppercase(str) {
			return str.toUpperCase();
		},
		startCache(data) {
			const itemKey = `hidden_package_${data.id}`;
			localforage.getItem(itemKey, (err, value) => {
				if (value) {
					// logic when no value
				} else {
					const image = data && data.file_path ? data.file_path : '';
					if (image) {
						this.cacheFile(itemKey, image);
					}
				}
			});
		},
		cacheFile(key, itemPath) {
			try {
				getVideoBlob(itemPath).then((blob) => {
				// Check videoBlob
				// Set key and blob
					localforage.setItem(key, blob, (err, value) => {
						if (!err && value) {
						// handle success cache here
						}
					});
				}).catch(() => {
				// error handling logic
				});
			} catch (e) {
			// catch some error here
			}
		},
		getImageLocalforage(data) {
			const itemKey = `hidden_package_${data.id}`;
			this.mediaSource = data && data.file_path ? data.file_path : '';
			localforage.getItem(itemKey).then((value) => {
				if (value) {
					this.mediaSource = URL.createObjectURL(value);
					return (this.mediaSource);
				}
				return (this.mediaSource);
			});
		},
	},
	watch: {},
	mounted() {
	},
	created() {
		dayjs.extend(relativeTime);
		this.fetch();
	},
	destroyed() {},
	beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
.page-template {
}
</style>
